<template>
    <b-modal
        v-model="modal"
        :title="'Input Name'"
        hide-footer
        centered
        @show="setData"
    >
        <b-form @submit.prevent="onSubmit">
            <b-form-group label="Set Name">
                <b-form-input v-model="form.setName" required></b-form-input>
            </b-form-group>
            <b-button type="submit" block variant="primary">Save</b-button>
        </b-form>
    </b-modal>
</template>

<script>
const INIT_FORM_DATA = {
    setName: '',
};
export default {
    name: 'AddOrEditSetModal',
    props: {
        value: {
            type: Boolean,
            required: true,
            default: false,
        },
        setName: {
            type: String,
            required: true,
        },
    },
    emits: {
        'update:setName': {
            type: String,
            required: true,
        },
    },
    computed: {
        modal: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    data() {
        return {
            form: {
                ...INIT_FORM_DATA,
            },
        };
    },
    methods: {
        setData() {
            this.form.setName = this.setName;
        },
        onSubmit() {
            this.$emit('onDone', this.form.setName);
            this.modal = false;
        },
    },
};
</script>
